webpackJsonp([5],{

/***/ 1580:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/404.c5472fb7.png";

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(90);

var _styledComponents = __webpack_require__(44);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _ = __webpack_require__(1580);

var _2 = _interopRequireDefault(_);

var _styledCommon = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Img = _styledComponents2.default.img.withConfig({
  displayName: '404__Img'
})(['width:300px;']);
var Div = (0, _styledComponents2.default)(_styledCommon.Flex).withConfig({
  displayName: '404__Div'
})(['min-height:100%;height:50vh;margin:0 auto;text-align:center;width:1000px;']);
exports.default = (0, _reactStatic.withSiteData)(function (_ref) {
  var siteData = _ref.siteData;
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      _reactStatic.Head,
      null,
      _react2.default.createElement(
        'title',
        null,
        'Page Not Found - ',
        siteData.site.name
      )
    ),
    _react2.default.createElement(
      Div,
      { flexDirection: 'column' },
      _react2.default.createElement(Img, { src: _2.default, alt: '404' }),
      _react2.default.createElement(
        'h1',
        null,
        'Woops... We couldn\'t find this page'
      )
    )
  );
});

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/404.ef114aaa.js